import React from "react";
import { Container, Card, Row, Col } from "react-bootstrap";
import NestedPageHero from "./NestedPageHero";

const LoopPage = () => {
  return (
    <div>
      <NestedPageHero title={"Loop"} />
      <Container className="my-5">
        <h1 className="text-center mb-4 text-warning">Loop: Functional Spaces</h1>
        <Row>
          <Col md={6}>
            <Card className="border-0 shadow">
              <Card.Img variant="top" src="/images/3.webp" height={300} />
              <Card.Body>
                <Card.Title>Compact Design</Card.Title>
                <Card.Text>
                  Smart layouts that maximize functionality and space.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="border-0 shadow">
              <Card.Img variant="top" src="/images/2.webp" height={300} />
              <Card.Body>
                <Card.Title>Storage Solutions</Card.Title>
                <Card.Text>
                  Integrated storage options for clutter-free living.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoopPage;
